<template>
    <div class="release">
        <header>
            <div class="header">
                <h2>我的发布</h2>
                <img src="@/assets/imgs/btn1.png" alt="" @click="router.push('/workbench/assets-lib/asset')" />
            </div>
            <div class="line"></div>
            <div class="input_box">
                <input type="text" v-model="queryParams.modelName" @change="query();" placeholder="请输入资产名称" />
                <van-icon name="search" color="#969696" size="20" />
            </div>
            <div class="tabs">
                <span @click="queryParams.assetSource = ''; query();" :class="{active: !queryParams.assetSource}">全部</span>
                <span @click="queryParams.assetSource = 1; query();" :class="{active: queryParams.assetSource == 1}">上传</span>
                <span @click="queryParams.assetSource = 2; query();" :class="{active: queryParams.assetSource == 2}">购买</span>
            </div>
        </header>
        <div class="query_params">
            <span @click="() => categoryPickerRef.openPicker()">{{ queryParams.platformCate ?
                queryParams.platformCateName : '平台分类' }} <van-icon name="arrow-down" /></span>
            <span @click="() => assetsResourcesPickerRef.openPicker()">{{ queryParams.assetSource ?
                queryParams.assetSourceName : '资产来源' }} <van-icon name="arrow-down" /></span>
            <span @click="() => assetsTypePickerRef.openPicker()">{{ queryParams.assetType ?
                queryParams.assetTypeName : '资产类型' }} <van-icon name="arrow-down" /></span>
            <span @click="() => timeRangePickerRef.openPicker()">发布时间 <van-icon name="arrow-down" /></span>
        </div>
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="list">
                <li v-for="item in list" :key="item.id">
                    <div class="name">
                        <p>{{ item.name }}</p>
                        <router-link :to="{'path': '/assets-detail', 'query': {id: item.id}}">查看</router-link>
                    </div>
                    <div class="line"></div>
                    <div class="content">
                        <img :src="item.picUrl ? item.picUrl.split(';')[0] : ''" alt="">
                        <div>
                            <p>大小 {{ item.modelSize }}</p>
                            <p>点赞次数 {{ item.thumbsUpCount }}</p>
                        </div>
                        <div>
                            <p>购买次数 0</p>
                            <p>查看次数 {{ item.browseCount }}</p>
                        </div>
                        <div>
                            <p>收藏次数 {{ item.favoriteCount }}</p>
                            <p>下载次数 {{ item.downloadCount }}</p>
                        </div>
                    </div>
                    <p class="time">创建时间 {{ timeStampFormat(item.createTime) || '-' }}</p>
                </li>
            </ul>
        </van-list>
    </div>


    <category-picker ref="categoryPickerRef"
        @confirm="d => { queryParams.platformCate = d[1].id; queryParams.platformCateName = d[1].name; query() }" />
    <assets-type-picker ref="assetsTypePickerRef"
        @confirm="d => { queryParams.assetType = d[0].id; queryParams.assetTypeName = d[0].name; query() }" />
    <assets-resources-picker ref="assetsResourcesPickerRef"
        @confirm="d => { queryParams.assetSource = d[0].id; queryParams.assetSourceName = d[0].name; query() }" />
    <time-range-picker ref="timeRangePickerRef"
        @confirm="d => { queryParams.createTime = d.startDate.getTime() + ',' + d.endDate.getTime(); query() }" />
        
</template>

<script setup>
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { timeStampFormat } from '@/utils/util'
import categoryPicker from '../../components/categoryPicker.vue'
import assetsTypePicker from '../../components/assetsTypePicker.vue'
import assetsResourcesPicker from '../../components/assetsResourcesPicker.vue'
import timeRangePicker from '../../components/timeRangePicker.vue'

// const showCategoryPicker = ref(false), showAssetPicker = ref(false), showAssetTypePicker = ref(false), showTimePicker = ref(false)
const categoryPickerRef = ref(null)
const assetsTypePickerRef = ref(null)
const assetsResourcesPickerRef = ref(null)
const timeRangePickerRef = ref(null)

const router = useRouter()
const store = useStore()
const queryParams = reactive({
    createTime: null,
    platformCate: null,  //平台分类
    platformCateName: null, //平台分类名称
    assetType: '',    //资产类型(1-模型;2-作品)
    assetTypeName: null, //资产类型名称
    assetSource: '', //资产来源(1-上传;2-购买)
    assetSourceName: null, //资产来源名称
    modelName: null  //资产名称
})
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
    total: 0
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    http.get('/app-api/product/spu/get-my-publish', {
        params: Object.assign({}, queryParams, pagination)
    }).then(res => {
        loading.value = false
        finished.value = res.list.length < pagination.pageSize
        pagination.total = res.total
        list.value = [...list.value, ...res.list]
    })
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}
onMounted(() => {
    fetchList()
})

</script>

<style lang="scss" scoped>
@use '../common.scss';

.release {
    background-color: #F6F6F6;
    min-height: 100vh;
    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }

    .list {
        padding-bottom: 50rem;

        li {
            background-color: #fff;
            width: 400rem;
            margin: 10rem auto;
            padding: 15rem;
            border-radius: 4rem;

            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14rem;

                a {
                    color: #0071BB;
                }
            }

            .line {
                width: 100%;
                height: 1rem;
                background-color: #F6F6F6;
                margin: 10rem 0;
            }

            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                img {
                    width: 65rem;
                    height: 54rem;
                    object-fit: cover;
                }

                div {
                    width: 18%;

                    p {
                        font-size: 12rem;
                        white-space: nowrap;
                        margin-bottom: 10rem;
                        color: #717171;
                    }
                }
            }

            .time {
                font-size: 12rem;
                color: #717171;
                margin-top: 10rem;
                text-align: right;
            }
        }
    }
}
</style>